import React, { useMemo } from 'react';

// helpers
import {
  useEntityIntakeFormContext,
  SUPPLEMENTARY_QUESTIONS_STEP_KEY_BASE,
} from '../EntityIntakeFormContext';

// components
import Review from './Review';
import Account from './Account';
import Funding from './Funding';
import StepsCard from 'components/Additional/StepsCard';
import BasicInfo from './BasicInfo';
import EntityType from './EntityType';
import EntityProfile from './EntityProfile';
import ServiceProviders from './ServiceProviders';
import AdditionalQuestions from './AdditionalQuestions';
import CustomersAndProducts from './CustomersAndProducts';
import AssociatedIndividuals from './AssociatedIndividuals';
import SupplementaryQuestions from './SupplementaryQuestions';

const IntakeForm = () => {
  const { steps, activeStepKey, intakeForm, selectStep } =
    useEntityIntakeFormContext();

  const contentNode = useMemo(() => {
    if (!activeStepKey || !intakeForm) {
      return null;
    }

    if (activeStepKey.includes(SUPPLEMENTARY_QUESTIONS_STEP_KEY_BASE)) {
      const formId = activeStepKey.replace(
        SUPPLEMENTARY_QUESTIONS_STEP_KEY_BASE,
        '',
      );
      return formId ? (
        <SupplementaryQuestions key={formId} formId={formId} />
      ) : null;
    }

    switch (activeStepKey) {
      case 'entity_type':
        return <EntityType />;

      case 'basic_info':
        return <BasicInfo />;

      case 'entity_profile':
        return <EntityProfile />;

      case 'customers_and_products':
        return <CustomersAndProducts />;

      case 'funding':
        return <Funding />;

      case 'account':
        return <Account />;

      case 'associated_individuals':
        return <AssociatedIndividuals />;

      case 'service_providers':
        return <ServiceProviders />;

      case 'additional_questions':
        return <AdditionalQuestions />;

      case 'review':
        return <Review />;

      default:
        return null;
    }
  }, [activeStepKey, intakeForm]);

  return (
    <StepsCard steps={steps} onSelect={selectStep} activeStep={activeStepKey}>
      {contentNode}
    </StepsCard>
  );
};

export default IntakeForm;
